import { memo } from "react";
import { MediasLogo } from "../../../Header/components/TopBar/MediasLogo";
import { useIsMinDesktopSize, useIsMinTabletSize } from "../../../common/hooks/useMediaQuery";
import { CART_PAGE, REGISTER_PAGE } from "../../../utils/url/staticUrls";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";

import classes from "./SPCompanyDetailsCardRightUnregistered.module.less";
import { trackPartnerFinderSearch } from "~/feature/Analytics/ga/salesPartner";
import { useFormContext } from "react-hook-form";
import type { SASearchFormFields } from "../SearchCard/SalesPartnerSearchBox";
import type { GoogleMarker } from "~/SalesPartner/salesPartnerTypes";
import { transformSelectedMarkerData } from "~/feature/cart/B2CRequestPage/utils";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

const SPCompanyDetailsCardRightUnregistered = (props: { company: GoogleMarker }) => {
  const isDesktop = useIsMinDesktopSize();
  const isTablet = useIsMinTabletSize();
  const { getValues } = useFormContext<SASearchFormFields>();

  const trackRegister = () => {
    trackPartnerFinderSearch(getValues(), "Register Intended", "Click", transformSelectedMarkerData(props.company));
  };

  const trackGoToCart = () => {
    trackPartnerFinderSearch(getValues(), "Go To Cart Intended", "Click", transformSelectedMarkerData(props.company));
  };

  if (isDesktop) {
    return <Desktop trackRegister={trackRegister} trackGoToCart={trackGoToCart} />;
  }

  return null;
};

const Desktop = (props: { trackRegister: () => void; trackGoToCart: () => void }) => {
  const { t } = useTranslation();
  return (
    <div className={classes.container}>
      <div className="scha__sales-partner__gmaps-sp-card__right__header__img-container">
        <MediasLogo variant={"plus"} />
      </div>
      <h3 className="title-large">{t("salesPartner.gmap.card.rightUnregistered.title")}</h3>
      <div className="scha__sales-partner__gmaps-sp-card__right__register">
        <div className="scha__sales-partner__gmaps-sp-card__right__register__instruction">
          <ol className="scha__sales-partner__gmaps-sp-card__right__register__instruction__list">
            <li>
              <Trans i18nKey={"salesPartner.gmap.card.rightRegistered.new.1step"} />
            </li>
            <li>
              <Trans i18nKey={"salesPartner.gmap.card.rightRegistered.new.2step"} />
            </li>
            <li>
              <Trans i18nKey={"salesPartner.gmap.card.rightRegistered.new.3step"} />
            </li>
          </ol>
          <div className={classes.buttonContainer}>
            <Button
              startIcon={<PersonOutlineOutlinedIcon />}
              fullWidth={true}
              data-test-id={"sales-partner-register-for-free"}
              href={REGISTER_PAGE}
              onClick={props.trackRegister}
            >
              {t("page.registerFree.title")}
            </Button>
            <Button
              href={CART_PAGE}
              startIcon={<ShoppingCartOutlinedIcon />}
              color="secondary"
              onClick={props.trackGoToCart}
            >
              {t("addToCartPopup.checkoutBtn")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SPCompanyDetailsCardRightUnregistered);
